import {Styles} from '../hooks/styles';

interface StylePatterns {
  flexCenterFull: Styles;
  flexCenterHorizontal: Styles;
  flexCenterVertical: Styles;
}

export const stylePatterns: StylePatterns = {
  flexCenterHorizontal: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
  },
  flexCenterVertical: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  flexCenterFull: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'row',
  },
};
